import React from "react";

const categories = [
    {
        img: "./img/categories/1.jpg",
        img_ms: "./img/categories/m1.jpg",
        link: "https://legrand.ru/for_designers/",
        title: <span>Дизайнерам <br/> и архитекторам</span>,
        download: false,
        max: 1024,
    },
    {
        img: "./img/categories/2.jpg",
        img_ms: "./img/categories/m2.jpg",
        link: "https://legrand.ru/products/",
        title: "Продукция",
        max: 768
    },
    {
        img: "./img/categories/3.jpg",
        img_ms: "./img/categories/m3.jpg",
        link: "https://e-catalogue.legrand.ru/",
        title: <span>Е-Каталог</span>,
        download: false,
        max: 768
    },
    {
        img: "./img/categories/4.jpg",
        img_ms: "./img/categories/m4.jpg",
        link: "https://legrand.ru/",
        title: <span>Legrand</span>,
        download: false,
        max: 768
    },
    {
        img: "./img/categories/5.jpg",
        img_ms: "./img/categories/m5.jpg",
        link: "https://legrand.ru/services/call-center/",
        title: <span>Техническая <br/> поддержка</span>,
        download: false,
        max: 768
    },
    {
        img: "./img/categories/6.jpg",
        img_ms: "./img/categories/m6.jpg",
        link: "https://configurator.legrand.ru/",
        title: <span>Конфигуратор</span>,
        download: false,
        max: 768
    },
    {
        img: "./img/categories/7.jpg",
        img_ms: "./img/categories/m7.jpg",
        link: "/docs/Tariff_RUS210917L.xlsx",
        title: <span>Тарифы</span>,
        download: true,
        max: 768
    },
]

const ItemContainer = ({ idx, link, download, img, img_ms, title, max }) => (
    <a className={`categories__item categories__item_${idx+1}`}
        href={link}
        target="_blank"
        download={download}
        >
        <picture>
            <source srcSet={img_ms} media={`(max-width: ${max}px)`}/>
            <img src={img} alt={title}/>
        </picture>
        <span className="categories__title">
            {title}
            <img src="./img/categories/arrow.svg" alt="icon"/>
        </span>
    </a>
)

export const Categories = () => {
    return (
        <div className="categories">
            <div className="categories__inner">
                <div className="categories__grid">
                    {categories.map((category, i)=> (
                        <ItemContainer 
                            key={i} idx={i} 
                            link={category.link}
                            title={category.title}
                            download={category.download}
                            img={category.img}
                            img_ms={category.img_ms}
                            max={category.max}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/pages/mainpage/Categories.js